// packages
import { observeIframe } from '@newswire/frames';

class DatawrapperEmbedComponent extends HTMLElement {
  connectedCallback() {
    const iframe = this.iframe;

    if (!iframe) {
      return;
    }

    this.unobserve = observeIframe(iframe);
  }

  disconnectedCallback() {
    if (this.unobserve) {
      this.unobserve();
      this.unobserve = undefined;
    }
  }

  get iframe() {
    return this.querySelector('iframe');
  }
}

if (!window.customElements.get('tmp-datawrapper-embed')) {
  window.DatawrapperEmbedComponent = DatawrapperEmbedComponent;
  window.customElements.define(
    'tmp-datawrapper-embed',
    DatawrapperEmbedComponent
  );
}
